import React from "react";
import { Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_LABEL } from "@/pages/admin/jobwork/jobWorkHelpers";

export const JobWorkFiltersBar = ({ filters, setFilters, karigars, onNewJob }) => (
  <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
    <div className="flex items-center gap-2 flex-wrap">
      <div className="relative">
        <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-muted-foreground" />
        <Input value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} placeholder="Search job # / karigar..." className="pl-8 w-52" />
      </div>
      <Select value={filters.karigar_id} onValueChange={(v) => setFilters({ ...filters, karigar_id: v })}>
        <SelectTrigger className="w-40"><SelectValue placeholder="Karigar" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All Karigars</SelectItem>{karigars.map((k) => <SelectItem key={k.id} value={k.id}>{k.name}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={filters.status} onValueChange={(v) => setFilters({ ...filters, status: v })}>
        <SelectTrigger className="w-40"><SelectValue placeholder="Status" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All Status</SelectItem>{Object.entries(STATUS_LABEL).map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
      </Select>
    </div>
    <Button data-testid="job-add-button" onClick={onNewJob} className="gap-2"><Plus className="h-4 w-4" /> New Job Work</Button>
  </div>
);
